export default [
  {
     "text": "Accueil",
    "icon": "ti-home",
    "route": "HOMES",
    "permission": "Voir la page d'acceuil",
    "module": "Dashbord"
  },
  {
    "text": "EFFECTIFS",
    "icon": "ti-user",
    "route": "agents",
    "permission": "Voir la page d'acceuil",
    "module": "Effectif"
  },
  {
    "text": "POSTES",
    "icon": "ti-clipboard",
    "route": "postes",
    "permission": "Voir la page d'acceuil",
    "modules": "Poste"
  },
  {
    "text": "RONDES",
    "icon": "ti-route",
    "route": "rondes",
    "permission": "Voir la page des rondes",
    "modules": "Rondes"
  },
   {
    "text": "Plannings",
    "icon": "ti-calendar-week",
    "route": "plannings",
    "permission": "Voir la page des rondes",
    "modules": "Rondes"
  },

  {
    "text": "MISE EN PLACE",
    "icon": "ti-calendar",
    "route": "",
    "module": "Listing",
    "submenu": [
      {
        "text": "Planification",
        "route": "modelslistings",
        "icon": "ti-calendar-check",
        "params": {
          "type": "brute"
        },
        "permission": "Voir la page des planifications"
      },
      {
        "text": "Aperçue listings",
        "route": "programmations",
        "icon": "ti-list-check",
        "params": {
          "type": "brute"
        },
        "permission": "Voir la page des listings"
      },
      {
        "text": "Listings valider1",
        "route": "programmations_LISTINGS_Valider1",
        "icon": "ti-eye-check",
        "params": {
          "type": "brute"
        },
        "permission": "Voir la page des listings valider par le responsable de mise en place"
      },
      {
        "text": "Listings valider2",
        "route": "programmations_LISTINGS_Valider2",
        "icon": "ti-eye-check",
        "params": {
          "type": "brute"
        },
        "permission": "Voir la page des listings valider par le chef de zone"
      },
      {
        "text": "Traitements des heures travaillées",
        "route": "ventilations",
        "icon": "ti-car-fan-auto",
        "params": {
          "type": "brute"
        },
        "permission": "Voir la page des ventilations"
      }
    ]
  },
  {
    "text": "RAPPORT",
    "icon": "ti-report-analytics",
    "route": "",
    "module": "Rapport",
    "submenu": [
      {
        "text": "Journal pointages",
        "icon": "ti-notes",
        "route": "journals",
        "params": {
          "type": "journal"
        },
        "permission": "Voir la page des pointages brutes"
      },
        {
        "text": "Journal pointages(Bis)",
        "icon": "ti-notes",
        "route": "journals2",
        "params": {
          "type": "journal"
        },
        "permission": "Voir la page des pointages brutes"
      },
      {
        "text": "Rapports Pointages",
        "route": "rapports",
        "icon": "ti-files",
        "params": {
          "type": "brute"
        },
        "permission": "Voir la page des pointages par postes"
      },
      {
        "text": "Pointeuses",
        "route": "pointeuses",
        "icon": "ti-devices",
        "permission": "Voir la page des pointeuses"
      }
    ]
  },
  {
    "text": "Configurations",
    "icon": "ti-settings",
    "route": "configurations",
    "permission": "Voir la page de Configurations",
    "module": "Configuration"
  },
  {
    "text": "Administration utilisateurs",
    "icon": "ti-settings",
    "route": "",
    "module": "Administration",
    "submenu": [
      {
        "text": "Utilisateurs",
        "route": "users",
        "icon": "ti-user",
        "permission": "Voir la page des utilisateurs"
      },
      {
        "text": "Les super admin",
        "route": "Users_SU",
        "icon": "ti-crown",
        "permission": "Voir la page des superAdmin",
        "isSu": true
      },
      {
        "text": "Roles / Profils",
        "route": "roles",
        "icon": "ti-id-badge",
        "params": {
          "type": "brute"
        },
        "permission": "Voir la page des roles"
      },
      {
        "text": "Permissions",
        "route": "permissions",
        "icon": "ti-key",
        "isSu": true,
        "params": {
          "type": "brute"
        },
        "permission": "Voir la page des permissions"
      },
      {
        "text": "Logs",
        "route": "surveillances",
        "icon": "ti-eye",
        "permission": "Voir la page des activites recentes"
      },
      {
        "text": "Entreprises",
        "route": "entreprises",
        "icon": "ti-briefcase",
        "isSu": true
      }
    ]
  }
]